<!-- JWNET未加入業者一覧 > JWNET未加入業者追加 -->
<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <Form />
  </v-container>
</template>

<script>

  import Form from './_Form'
  // import BasicForm from './forms/_Basic'

  export default {
    name: 'DriverMasterNonSubscribeTraderNew',
    components: {
      Form,
    },
    mixins: [
    ],
    data () {
      return {
        product: null,
        breadcrumbs: [
          { text: 'JWNET未加入業者一覧', disabled: false, to: '/driver/masters/non_subscribe_traders', exact: true },
          { text: 'JWNET未加入業者追加', disabled: true, to: '' },
        ],
        non_subscribe_trader: null
      }
    },
    created() {
    },
    methods: {
    }
  }
</script>

<style lang="scss">

</style>
